/**
 * @fileoverview gRPC-Web generated client stub for acompanha.auth.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/auth/v1/auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.auth = {};
proto.acompanha.auth.v1 = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.auth.v1.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.auth.v1.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.auth.v1.LoginRequest,
 *   !proto.acompanha.auth.v1.LoginResponse>}
 */
const methodDescriptor_AuthService_Login = new grpc.web.MethodDescriptor(
  '/acompanha.auth.v1.AuthService/Login',
  grpc.web.MethodType.UNARY,
  proto.acompanha.auth.v1.LoginRequest,
  proto.acompanha.auth.v1.LoginResponse,
  /**
   * @param {!proto.acompanha.auth.v1.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.auth.v1.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.auth.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.auth.v1.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.auth.v1.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.auth.v1.AuthServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login,
      callback);
};


/**
 * @param {!proto.acompanha.auth.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.auth.v1.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.auth.v1.AuthServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.auth.v1.RegisterRequest,
 *   !proto.acompanha.auth.v1.RegisterResponse>}
 */
const methodDescriptor_AuthService_Register = new grpc.web.MethodDescriptor(
  '/acompanha.auth.v1.AuthService/Register',
  grpc.web.MethodType.UNARY,
  proto.acompanha.auth.v1.RegisterRequest,
  proto.acompanha.auth.v1.RegisterResponse,
  /**
   * @param {!proto.acompanha.auth.v1.RegisterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.auth.v1.RegisterResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.auth.v1.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.auth.v1.RegisterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.auth.v1.RegisterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.auth.v1.AuthServiceClient.prototype.register =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Register',
      request,
      metadata || {},
      methodDescriptor_AuthService_Register,
      callback);
};


/**
 * @param {!proto.acompanha.auth.v1.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.auth.v1.RegisterResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.auth.v1.AuthServicePromiseClient.prototype.register =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Register',
      request,
      metadata || {},
      methodDescriptor_AuthService_Register);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.auth.v1.MeRequest,
 *   !proto.acompanha.auth.v1.MeResponse>}
 */
const methodDescriptor_AuthService_Me = new grpc.web.MethodDescriptor(
  '/acompanha.auth.v1.AuthService/Me',
  grpc.web.MethodType.UNARY,
  proto.acompanha.auth.v1.MeRequest,
  proto.acompanha.auth.v1.MeResponse,
  /**
   * @param {!proto.acompanha.auth.v1.MeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.auth.v1.MeResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.auth.v1.MeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.auth.v1.MeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.auth.v1.MeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.auth.v1.AuthServiceClient.prototype.me =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Me',
      request,
      metadata || {},
      methodDescriptor_AuthService_Me,
      callback);
};


/**
 * @param {!proto.acompanha.auth.v1.MeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.auth.v1.MeResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.auth.v1.AuthServicePromiseClient.prototype.me =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.auth.v1.AuthService/Me',
      request,
      metadata || {},
      methodDescriptor_AuthService_Me);
};


module.exports = proto.acompanha.auth.v1;

